import { render, staticRenderFns } from "./NewBillsItem.vue?vue&type=template&id=320ea500&scoped=true&"
import script from "./NewBillsItem.vue?vue&type=script&lang=js&"
export * from "./NewBillsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ea500",
  null
  
)

export default component.exports